import {SummaryModel} from "../../../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../../../common/entity/permissions.model";

export class TreatmentJourneyDefinitionSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    active: boolean;
    visibleInExternalApplication: boolean;
    label: string;
}